import { jsxs, jsx } from 'react/jsx-runtime';
import logger from '@agoras/logger';
import { mergeStyleSets, FontWeights, FontSizes, Stack, Text, Link } from '@fluentui/react';
import { AppContext } from '../../../context/context.esm.js';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { headerContext } from '../../context.esm.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var classNames = mergeStyleSets({
    title: {
        fontSize: FontSizes.size16,
        fontWeight: FontWeights.semibold
    }
});
function AllPanelHeader(param) {
    var title = param.title, url = param.url, onClick = param.onClick;
    var navigate = useContext(AppContext).navigate;
    var t = useTranslation('header').t;
    return /*#__PURE__*/ jsxs(Stack, {
        horizontal: true,
        verticalAlign: "baseline",
        tokens: {
            childrenGap: 10
        },
        children: [
            /*#__PURE__*/ jsx(Text, {
                className: classNames.title,
                children: t(title)
            }),
            /*#__PURE__*/ jsx(Link, {
                onClick: function() {
                    logger.info(JSON.stringify({
                        key: title,
                        name: 'See all'
                    }), _object_spread({
                        action: 'AllMenu',
                        actionModifier: 'Link'
                    }, headerContext));
                    navigate({
                        type: url.filterType
                    });
                    onClick();
                },
                children: t('See all')
            })
        ]
    });
}

export { AllPanelHeader as default };
